import React from 'react';
import styles from './styles/styles.module.scss';
import CommunitySectionSwitch from '../CommunitySectionSwitch';

const Feed = ({ feed }) => {
  return feed.activities.map(activity => {
    return <CommunitySectionSwitch {...activity} />;
  });
};

Feed.defaultProps = {
  feed: []
};

export default Feed;
